import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';

import { ISpaceMalFormedListResponse } from 'src/app/shared/interfaces';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule, MatDateRangeInput } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBar, MatSnackBarModule, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  IGX_GRID_DIRECTIVES,
  IgxActionStripModule,
  IgxExcelExporterOptions,
  IgxExcelExporterService,
  IgxGridComponent,
  IgxGridModule,
  IgxSwitchModule,
  IgxTabsModule,
  IPinningConfig,
  RowPinningPosition,
} from '@infragistics/igniteui-angular';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { MessageDialogService } from 'src/app/core/services/helper/message-dialog.service';
import { IAgingCommentsDialogUpdate, IInvoiceAsOfAgingResult } from 'src/app/shared/interfaces';
import { HeaderTitleLotDataComponent } from 'src/app/shared/ui/header-title-lot-data/header-title-lot-data.component';
import { environment } from 'src/environments/environment';
import { IgxPreventDocumentScrollModule } from 'src/app/shared/directives/prevent-scroll.directive';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-admin-patch-malformed-space-accounts',
  standalone: true,
  imports: [
    MatSlideToggleModule,
    MatExpansionModule,
    MatIconModule,
    CommonModule,
    MatTabsModule,
    MatSnackBarModule,
    MatTableModule,
    MatCardModule,
    MatOptionModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    IgxGridModule,
    IgxTabsModule,
    IgxGridComponent,
    HeaderTitleLotDataComponent,
    MatTooltipModule,
    MatButtonModule,
    MatDialogModule,
    IgxActionStripModule,
    IgxSwitchModule,
    IgxPreventDocumentScrollModule,
    MatCheckboxModule,
    FormsModule,
  ],
  templateUrl: './admin-patch-malformed-space-accounts.component.html',
  styleUrl: './admin-patch-malformed-space-accounts.component.scss',
})
export class AdminPatchMalformedSpaceAccountsComponent implements OnInit {
  badSpaceAccountList: ISpaceMalFormedListResponse[] = [];

  //Services
  _dataService = inject(DataService);
  _route = inject(ActivatedRoute);
  _router = inject(Router);
  _appGeneralState = inject(AppGeneralStateService);
  _destroyRefService = inject(DestroyRef);
  #_messageDialogService = inject(MessageDialogService);

  ngOnInit(): void {
    this.getMalformedSpaceAccounts();
  }

  getMalformedSpaceAccounts() {
    this._dataService
      .getSpaceMalformedAccounts()
      .pipe(takeUntilDestroyed(this._destroyRefService))
      .subscribe({
        next: (res) => {
          this.badSpaceAccountList = res;
        },
        error: (err: any) => {
          this.#_messageDialogService.snackBarTopCenterTimed(
            'An error occurred while checking to see if any spACE accounts were malformed',
            5000,
          );
        },
        complete: () => {},
      });
  }

  onUpdateAndFixSpaceEmailAccounts(): void {
    this.fixAllMalformedSpaceAccounts();
  }

  fixAllMalformedSpaceAccounts(): void {
    this._dataService
      .fixAllMalformedSpaceAccounts()
      .pipe(takeUntilDestroyed(this._destroyRefService))
      .subscribe({
        next: (res) => {},
        error: (err: any) => {
          this.#_messageDialogService.snackBarTopCenterTimed(
            'An error occurred while correctingy spACE accounts',
            5000,
          );
        },
        complete: () => {
          this.getMalformedSpaceAccounts();
        },
      });
  }
}
